import Tip from "../Tools/Tip";
import { Link } from "react-router-dom";
import NextButton from "./NextButton";
import useCurrentSection from "./Hooks/useCurrentSection";
import { useParams } from "react-router-dom";
import useIsLocked from "./Hooks/useIsLocked"
import useCourse from "./Hooks/useCourse"
import { txt } from "../../services/translation";

export default function Footer(){

    const section = useCurrentSection()

    const [isLocked] = useIsLocked()

    const showButton = !isLocked && !['quiz'].includes(section?.type.id)

    return <footer className='study-footer'>

        {section && <>

            <div className='study-footer-left'></div>

            <NextButton show={showButton} />

            <Right />
            
        </>}
        
    </footer>   
}




function Right(){

    const p = useParams()

    const course = useCourse();

    const optionIs = o => o === p.option

    return <div className='study-footer-right'>

        {!optionIs('note') && (
            <Link to={`/study/${p.course}/${p.tab}/note`}>
                <Tip type='edit' title={txt('takeNotes')} />
            </Link>
        )}

        {course.forum && !optionIs('post') && (
            <Link to={`/study/${p.course}/${p.tab}/post`}>
                <Tip type='chat' title={txt('askQuestion')} />
            </Link>
        )}


    </div>
}